import React from 'react';
import {mapUserToRecipient} from '../helpers/mailHelper';
import {Link, EntityTable,LoadingIndicator} from 'arkulpa-fec';

const _tableConfig = maxRows => {
  return {
    maxRows,
    cols: [
      {
        header: 'Name',
        valueKey: '*',
        method: ({firstName, lastName}) => lastName + ' ' + firstName,
        width: '25%',
      },
      {
        header: 'Email',
        valueKey: '*',
        method: user => (
          <span onClick={e => e.stopPropagation()}>
            <Link href={'mailto:' + mapUserToRecipient(user)}>{user.email}</Link>
          </span>
        ),
        width: '25%',
      },
      {
        header: 'Phone',
        valueKey: 'phone',
        method: phone => phone,
        width: '25%',
      },
      {
        header: 'Role',
        valueKey: 'role',
        method: role => role,
        width: '25%',
      },
    ],
  };
};

export default ({loading, users, history, maxRows = 30}) => (
  <div>
    <EntityTable
      tableConfig={_tableConfig(maxRows)}
      data={loading ? [] : users}
      msg={'Noch keine Benutzer erstellt'}
      onRowClicked={row => history.push('/user/' + row._id)}
    />
    {loading && <LoadingIndicator />}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/UserList.js